export const SCHEDULED_START_TIME_STEP_MINUTES = 30
export const DEFAULT_SCHEDULED_START_TIME = '07:00:00'

const SCHEDULED_START_HOUR_MIN = 5
const SCHEDULED_START_HOUR_MAX = 22

export const SCHEDULED_START_TIMES: readonly string[] = (() => {
  const slots: string[] = []
  for (let h = SCHEDULED_START_HOUR_MIN; h <= SCHEDULED_START_HOUR_MAX; h++) {
    for (let m = 0; m < 60; m += SCHEDULED_START_TIME_STEP_MINUTES) {
      if (h === SCHEDULED_START_HOUR_MAX && m > 0) break
      slots.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:00`)
    }
  }
  return slots
})()
